import React from "react";
import FlightCheckerBase from "./FlightCheckerBase";

export default function FlightCheckerT4() {
  return (
    <FlightCheckerBase
      terminal="4"
      defaultFlight="GF006"
      title="Heathrow Terminal 4 Flight Checker | Live T4 Flight Status, Queues, Gate & Reliability"
      metaDescription="Check Heathrow Terminal 4 flights by number with live T4 flight status, arrivals/departures, gate, check-in zone, immigration or security queue times and recent reliability context."
      metaKeywords="Heathrow Terminal 4 flight checker, Heathrow T4 flight status, Heathrow Terminal 4 arrivals, Heathrow Terminal 4 departures, Heathrow T4 gate, Heathrow T4 check-in zone, T4 immigration wait time, T4 security wait, Heathrow T4 reliability"
      canonical="https://www.cheapcabgrab.com/terminal-4-flight-checker"
      ogTitle="Heathrow Terminal 4 Flight Checker | Live T4 Status, Queues & Gate"
      ogDescription="Check Heathrow Terminal 4 flights for live status, arrivals or departures, gate, check-in zone, queue times and flight reliability."
      schemaName="Heathrow Terminal 4 Flight Checker"
      breadcrumbName="Terminal 4 Flight Checker"
      headerTitle="Heathrow Terminal 4 Flight Checker"
      headerIntro="Check Heathrow Terminal 4 arrivals and departures with terminal-specific queue times, gate details and reliability context."
      headerNote="Choose the exact Heathrow Terminal 4 arrival or departure time. Today, recent past flights and the next few days are included."
      inputPlaceholder="e.g. GF006"
      emptyInputMessage="Please enter a Terminal 4 flight number (e.g. GF006)."
      notFoundMessage="Flight not found at Heathrow Terminal 4 for the selected time. Please choose another listed Terminal 4 flight."
      resultHeading="Heathrow Terminal 4 Flight Details"
      pickupLabel="Calculate Terminal 4 pickup window →"
      faqTitle="Terminal 4 FAQs"
      faqItems={[
        { question: "How busy is Heathrow Terminal 4 security today?", answer: "Terminal 4 can be quieter overall, but evening long-haul banks can make security busier." },
        { question: "Is Terminal 4 slower than other terminals?", answer: "It depends; Terminal 4 immigration can bottleneck during evening long-hauls, so allow extra buffer." },
        { question: "Does Terminal 4 have eGates?", answer: "Yes, eGates are available for eligible passports at Terminal 4." },
        { question: "How long does it take to exit Terminal 4 after landing?", answer: "Typically 45–90 minutes depending on passport type and baggage." },
        { question: "Where should drivers wait for Terminal 4 pickups?", answer: "Use Short Stay once the passenger confirms they are landside." },
        { question: "Does Terminal 4 have long walking distances?", answer: "Moderate walks; allow time from some remote stands and for evening crowds." },
      ]}
    />
  );
}
